var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "py-2 px-0", attrs: { "grid-list-sm": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex"),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: { width: "36px", border: "solid 2px #4E342E" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "caption",
                            staticStyle: { color: "#4E342E" }
                          },
                          [_vm._v("A12")]
                        )
                      ]
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Regular")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: { width: "36px", border: "solid 2px #2979FF" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c("v-icon", { attrs: { color: "blue accent-3" } }, [
                          _vm._v("accessible")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Wheelchair")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: { width: "36px", border: "solid 2px #FF6D00" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c("v-icon", { attrs: { color: "orange accent-4" } }, [
                          _vm._v("star")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   VIP")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: { width: "36px", border: "solid 2px #B388FF" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: "deep-purple accent-1" } },
                          [_vm._v("airline_seat_recline_extra")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Recliner")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-left-sofa-legend",
                    staticStyle: {
                      width: "36px",
                      border: "solid 2px #9E9D24",
                      "border-right-width": "1px"
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "caption",
                            staticStyle: { color: "#9E9D24" }
                          },
                          [_vm._v("G15")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "layout-right-sofa-legend",
                    staticStyle: {
                      width: "36px",
                      border: "solid 2px #9E9D24",
                      "border-left-width": "1px"
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "caption",
                            staticStyle: { color: "#9E9D24" }
                          },
                          [_vm._v("G16")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Sofa")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: { width: "36px", border: "solid 2px #FDD835" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "caption",
                            staticStyle: { color: "#FDD835" }
                          },
                          [_vm._v("G15")]
                        )
                      ]
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Companion")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: { width: "36px", border: "solid 2px #FFCDD2" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c("v-icon", { attrs: { color: "red lighten-4" } }, [
                          _vm._v("build")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Broken")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", [
                _c(
                  "div",
                  {
                    staticClass: "layout-seat-legend",
                    staticStyle: {
                      width: "36px",
                      border: "solid 2px #E0E0E0",
                      background: "#E0E0E0"
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "layout-seat-name subheading text-xs-center",
                        staticStyle: { "margin-top": "-2px" },
                        attrs: { slot: "activator" },
                        slot: "activator"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "caption",
                            staticStyle: { color: "#9E9E9E" }
                          },
                          [_vm._v("A12")]
                        )
                      ]
                    )
                  ]
                ),
                _c("p", { staticStyle: { "margin-top": "2px" } }, [
                  _vm._v("   Sold")
                ])
              ]),
              _vm._v(" "),
              _c("v-flex")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9f9a99a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9f9a99a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/Legend.vue
// module id = null
// module chunks = 